import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicModule } from '../public/public.module';
import { ProtectedModule } from '../protected/protected.module';
import { FacadeService } from './services/facade.service';
import { LogService } from './services/log/log.service';
@NgModule({
	imports: [CommonModule, PublicModule, ProtectedModule],
	exports: [],
	providers: [FacadeService, LogService],
	declarations: []
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule is already loaded.');
		}
	}
}
